<template>
    <div class="add-item">
        <el-dropdown placement="bottom-start" @command="handleAddItem">
          <span class="el-dropdown-link">
            <i class="el-icon-circle-plus-outline"></i> Dodaj <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="text">Pole tekstowe</el-dropdown-item>
            <el-dropdown-item v-if="loggedIn" command="personalized-field">Pole personalizowane</el-dropdown-item>
            <el-dropdown-item v-if="loggedIn" command="slot">Ustaw jako slot na zdjęcie</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Editor from '../../../classes/Editor'

export default {
    computed: {
        ...mapGetters('user', [
            'loggedIn',
        ]),
    },
    methods: {
        async handleAddItem(type) {
            const obj = Editor.canvas.getActiveObject()

            switch (type) {
                case 'text':
                    Editor.addText('To jest przykładowy tekst. Kliknij dwa razy, aby edytować.', {
                        width: Editor.width - 20,
                        textAlign: 'center',
                    })
                break
                case 'personalized-field':
                    Editor.addText('[Pole personalizowane]', {
                        id: 'personalizedField',
                        left: 0,
                        top: 0,
                        textAlign: 'center',
                        editable: false,
                        width: Editor.width
                    })
                break
                case 'slot':
                    if (obj && obj.type == 'image') {
                        Editor.setSlot(obj)
                    } else if (obj) {
                        this.$alert('Aktywny element nie jest obrazkiem. Zaznacz obrazek i spróbuj ponownie', 'Ups')
                    } else {
                        this.$alert('Aby ustawić slot na zdjęcie najpierw wybrać element z obrazkiem', 'Ups')
                    }
                break
            }
        },
    },
}
</script>